import * as types from '../constants';

const initialState = {
  count: 0,
  totalPages: 1,
};

function pagination(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USERS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default pagination;
